import CreateAccountSuccessModal from "./CreateAccountSuccessModal";

export default CreateAccountSuccessModal;
